import { style } from '@vanilla-extract/css';
import { themeVars } from '../themeVars.css';

export const disabledClass = style({
  opacity: `${0.6}!important`,
  cursor: 'not-allowed !important',
  filter: 'grayscale(100%)',
});

export const defaultTransitionClass = style({
  transition: themeVars.transitions.default,
});

export const clickableClass = style([
  defaultTransitionClass,
  {
    cursor: 'pointer',
    selectors: {
      [`:hover&:not(${disabledClass})`]: {
        scale: 1.03,
      },
      [`:active&:not(${disabledClass})`]: {
        scale: 1,
      },
    },
  },
]);

export const interactableClass = style([
  defaultTransitionClass,
  {
    cursor: 'pointer',
  },
]);

export const textEllipsisClass = style({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const clickableTextClass = style([
  defaultTransitionClass,
  {
    textDecoration: 'underline',
    cursor: 'pointer',

    selectors: {
      '&:hover': {
        color: themeVars.colors.neutrals.grey70,
      },
    },
  },
]);

export const fieldTooltipIcon = style({
  position: 'absolute',
  top: '4px',
  right: '2px',
  fontSize: themeVars.font.size.textLg,
});

export const textUppercaseClass = style({
  textTransform: 'uppercase',
});

export const textCenterClass = style({
  textAlign: 'center',
  margin: 'auto',
});
